import jsLogger from 'js-logger'

export type QualityLevel = {
  fps: number
  scale: number
}

const LEVELS: QualityLevel[] = [
  { fps: 24, scale: 1.0 }, // 0 — perfect
  { fps: 18, scale: 1.0 }, // 1 — ок
  { fps: 15, scale: 0.85 }, // 2 — bad
  { fps: 12, scale: 0.75 } // 3 — poor
]

export default class RecordingQualityController {
  private level = 0
  private lastChange = 0

  constructor(private readonly onChange: (q: QualityLevel) => void) {}

  update(queueSize: number) {
    jsLogger.log('RecordingQualityController:update, queueSize', queueSize)
    const now = performance.now()
    if (now - this.lastChange < 2000) return // anti-flap

    let next = this.level

    if (queueSize >= 10) next = 3
    else if (queueSize >= 5) next = 2
    else if (queueSize >= 3) next = 1
    else next = 0

    if (next !== this.level) {
      this.level = next
      this.lastChange = now
      jsLogger.log('changing video quality to ', LEVELS[this.level])
      this.onChange(LEVELS[this.level])
    }
  }

  get current() {
    return LEVELS[this.level]
  }
}
